export default (countryLabel) => ({
    countryName: null,
    activeCountryLabel: countryLabel,
    showList: false,

    init() {
        if (!countryLabel) {
            throw new error('No country label provided')
        }

        this.setAndShortenCountryLabel(countryLabel)
    },

    switchCountry(isoCode, label) {
        if (!isoCode || !label) {
            throw new error('No country code or label provided')
        }

        const shopDomain = (typeof orbito !== 'undefined' && orbito.getCountryDomain) ? (orbito.getCountryDomain() || window.location.hostname) : window.location.hostname;

        const form = this.$root.querySelector('form')
        const countryCodeInput = form.querySelector('input[name="country_code"]')
        const returnToInput = form.querySelector('input[name="return_to"]')

        countryCodeInput.value = isoCode
        this.setAndShortenCountryLabel(label)

        if (returnToInput.value.match(/(\?|&)country=[^&]*/)) {
            returnToInput.value = returnToInput.value.replace(/(\?|&)country=[^&]*/, `$1country=${isoCode}`);
        } else {

            if (returnToInput.value.includes('?')) {
                returnToInput.value += `&country=${isoCode}`
            } else {
                returnToInput.value += `?country=${isoCode}`
            }
        }

        document.cookie = `mdApp_countryCodeDomain=${isoCode}; domain=${shopDomain}; path=/; max-age=${60 * 60 * 24 * 60};`

        this.$nextTick(() => form.submit())
    },

    setAndShortenCountryLabel(countryLabel) {
        const splitLabel = countryLabel.split('|')

        const fullCountryName = splitLabel[0].trim()
        const shortCountryName = window.shopifyData.countryNames[fullCountryName] || fullCountryName
        const restOfLabel = splitLabel[1].trim()
        
        this.activeCountryLabel = `${shortCountryName} | ${restOfLabel}`
    }
})
